module.exports = __webpack_public_path__ + "static/media/1010.e58da978.png";